<script setup lang="ts">
import { ref } from 'vue';

import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';

const emit = defineEmits<{
  (e: 'save', note: string): void;
  (e: 'cancel'): void;
}>();

const noteValue = ref('');
const modalVisible = ref(true);

const save = () => {
  emit('save', noteValue.value);
  return;
};

const cancel = () => {
  emit('cancel');
  return;
};
</script>

<template>
  <Dialog
    v-model:visible="modalVisible"
    class="dialog__container add-note__modal"
    :draggable="false"
    :modal="true"
    @hide="cancel"
  >
    <template #header>
      <div class="dialog__header">
        <h2 v-text="'Add Note'" />
      </div>
    </template>
    <Textarea v-model="noteValue" class="w-full" :auto-resize="true" rows="7" cols="77" autofocus />
    <template #footer>
      <AppButton id="cancel_notes_btn" type="secondary" text="Cancel" @click="cancel" />
      <AppButton id="save_notes_btn" type="primary" :text="'Add Note'" :disabled="!noteValue.length" @click="save" />
    </template>
  </Dialog>
</template>

<style lang="scss" scoped>
.dialog__container {
  .p-dialog-content {
    padding: 1rem;
  }
  .dialog__header {
    display: flex;
    flex-direction: column;
  }
}
</style>
